import { render, staticRenderFns } from "./GMovableButtons.vue?vue&type=template&id=62d46d0c&scoped=true&"
import script from "./GMovableButtons.vue?vue&type=script&lang=ts&"
export * from "./GMovableButtons.vue?vue&type=script&lang=ts&"
import style0 from "./GMovableButtons.vue?vue&type=style&index=0&id=62d46d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d46d0c",
  null
  
)

export default component.exports